import React, { useEffect, useState } from 'react'

interface Props {
  isLoading?: boolean
  style?: React.CSSProperties
}

const Loader = ({ isLoading = false, style }: Props): JSX.Element => {
  const [isVisible, setIsVisible] = useState(isLoading)

  useEffect(() => {
    if (isLoading) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }, [isLoading])

  if (!isVisible) {
    return <></>
  }

  return (
    <>
      <div className="bigLoader" style={style}>
        <div className="smallLoader" />
      </div>

      <style>{`
        .bigLoader {
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          border: 4px solid rgba(255, 255, 255, 0.2);
          border-top-color: white;
          animation: spin 1.5s linear infinite;
        }

        .smallLoader {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          border: 4px solid rgba(255, 255, 255, 0.2);
          border-top-color: white;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  )
}

export default Loader
